import * as React from 'react';
import type { AreaViewModel } from '~/Partials/Accordion/AreaViewModel.csharp';
import { AccordionItem } from '~/Partials/AccordionComponent/AccordionItem';
import { Link } from '~/Partials/Link/Link';
import { List } from '~/Partials/List/List';
import { ResearchPublication } from '~/Partials/ResearchPublication/ResearchPublication';
import styles from './EmployeeDetails.module.css';
import type { EmployeeDetailsViewModel } from './ViewModel/EmployeeDetailsViewModel.csharp';
import type { BaseEntryViewModel } from './ViewModel/Entry/BaseEntryViewModel.csharp';
import type { EmployeeResearchViewModel } from './ViewModel/Entry/EmployeeResearchViewModel.csharp';
import type { IEntryViewModel } from './ViewModel/Entry/IEntryViewModel.csharp';

export class EmployeeDetails extends React.Component<EmployeeDetailsViewModel> {
    isBaseEntry(entry: IEntryViewModel) {
        return (entry as BaseEntryViewModel).lines !== undefined;
    }

    renderBaseEntry(entry: BaseEntryViewModel) {
        const heading = entry.headingUrl ? (
            <Link className={styles.LinkEntry} href={entry.headingUrl} label={entry.heading} />
        ) : (
            entry.heading
        );

        return (
            <>
                <div>{heading}</div>
                {entry.lines && entry.lines.map((line, lineIdx) => <div key={lineIdx}>{line}</div>)}
            </>
        );
    }

    renderEntry(entry: IEntryViewModel) {
        if (this.isBaseEntry(entry)) {
            return this.renderBaseEntry(entry as BaseEntryViewModel);
        }

        return <ResearchPublication {...(entry as EmployeeResearchViewModel).researchPublicationViewModel} />;
    }

    renderArea(area: AreaViewModel, id: string) {
        const hasCategories =
            area.categories && area.categories.length > 0 && area.categories.some(x => x.entries.length > 0);
        const hasEntries = area.entries && area.entries.length > 0;
        const hasContent = hasCategories || hasEntries;

        return (
            hasContent && (
                <li key={id} className={styles.AccordionWrapper}>
                    <AccordionItem
                        headerContent={<h3 className={styles.AccordionTitle}>{area.displayName}</h3>}
                        contentSpacing="fullWidth"
                    >
                        {hasCategories &&
                            area.categories.map(
                                category => category && this.renderEntries(category.entries, category.displayName)
                            )}

                        {hasEntries && this.renderEntries(area.entries, '')}
                    </AccordionItem>
                </li>
            )
        );
    }

    renderEntries(entries: IEntryViewModel[], heading: string) {
        return (
            entries &&
            entries.length > 0 && (
                <div className={styles.Entries}>
                    {heading && <h4 className={styles.Heading}>{heading}</h4>}
                    <ul className={styles.List}>
                        {entries.map((entry, idx) => (
                            <li key={idx}>{this.renderEntry(entry)}</li>
                        ))}
                    </ul>
                </div>
            )
        );
    }

    render() {
        const { areas } = this.props;

        return (
            <List
                items={areas}
                renderItem={(area, idx) => this.renderArea(area, `area-${idx}`)}
                className={styles.EmployeeDetails}
            />
        );
    }
}
